var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sub-content-container',{attrs:{"title":_vm.$t('aboutMe.abilities.pageLabel')}},_vm._l((_vm.completeAbilities),function(ability,i){return _c('ability',{key:("ability-" + i),attrs:{"ability":ability}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }